interface Props {
  color: string | "#D0DEE6",
}
const Contrast = (props: Props) => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="58" height="58" rx="4" fill="white" stroke={props.color} strokeWidth="2"/>
      <path d="M20.7118 39.5182C18.1783 36.9517 16.9116 33.8578 16.9116 30.2365C16.9116 26.6152 18.1783 23.5389 20.7118 21.0075C23.2804 18.441 26.3768 17.1577 30.001 17.1577C33.6252 17.1577 36.704 18.441 39.2375 21.0075C41.8061 23.5389 43.0904 26.6152 43.0904 30.2365C43.0904 33.8578 41.8061 36.9517 39.2375 39.5182C36.704 42.0496 33.6252 43.3153 30.001 43.3153C26.3768 43.3153 23.2804 42.0496 20.7118 39.5182ZM30.001 39.9401C32.6752 39.9401 34.9623 38.9908 36.8624 37.0923C38.7624 35.1938 39.7125 32.9085 39.7125 30.2365C39.7125 27.5645 38.7624 25.2792 36.8624 23.3807C34.9623 21.4822 32.6752 20.5329 30.001 20.5329V39.9401Z" fill={props.color}/>
    </svg>
  )
}
export default Contrast;
